import { Button, CloseButton, Dialog, Portal } from '@chakra-ui/react';
import { t } from 'i18next';
import { useState } from 'react';
import { FaTrash } from 'react-icons/fa';

export const ManageCollecteDeleteDialog = ({
  open: controlledOpen,
  hideTrigger = false,
  onOpenChange,
  onCancel,
  onDelete,
}: {
  open?: boolean;
  hideTrigger?: boolean;
  onOpenChange?: (open: boolean) => void;
  onCancel?: () => void;
  onDelete?: () => void;
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);

  const open = controlledOpen ?? uncontrolledOpen;
  const setOpen = onOpenChange ?? setUncontrolledOpen;

  return (
    <Dialog.Root role="alertdialog" open={open} onOpenChange={(e) => setOpen(e.open)}>
      {!hideTrigger && (
        <Dialog.Trigger asChild>
          <Button size="sm" bg={'red.500'}>
            <FaTrash />
            {t('ui.delete')}
          </Button>
        </Dialog.Trigger>
      )}
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>{t('messages.headers.areYouSure')}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <p>{t('messages.hints.collection.deleteConfirmation')}</p>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" onClick={onCancel}>
                  {t('ui.cancel')}
                </Button>
              </Dialog.ActionTrigger>
              <Button colorPalette="red" onClick={onDelete}>
                {t('ui.delete')}
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" mt="2" mr="4" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
